import { useEffect } from 'react'

import { useSession } from 'next-auth/react'

export default function useKlaviyoIdentify() {
	const { data: session } = useSession()

	useEffect(() => {
		const customer = session?.user?.customer
		if (!customer?.email || typeof window === 'undefined' || !window.klaviyo) return

		window.klaviyo.identify({
			$email: customer.email,
			$first_name: customer.firstName,
			$last_name: customer.lastName,
		})
	}, [session])
}
